<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Organization details' | translate }}</h4>
  </div>
  <div class="modal-body">
    <form [formGroup]="organizationForm" class="row">
      <div class="col-12 col-sm-6">
        <h5 class="text-muted text-uppercase">{{ 'Details' | translate }}</h5>
        <div class="row">
          <div class="form-group col-12">
            <label for="name">{{ 'Name' | translate }} *</label>
            <input
              #settingsName
              type="text"
              class="form-control"
              tabindex="0"
              id="name"
              [class.is-invalid]="
                sent && organizationForm?.get('name').hasError('required')
              "
              formControlName="name"
            />

            <span
              class="invalid-feedback"
              *ngIf="sent && organizationForm?.get('name').hasError('required')"
              >{{ 'global.validators.required.error' | translate }}</span
            >
          </div>
          <div class="form-group col-12">
            <label for="address">{{ 'Address' | translate }}</label>
            <input
              tabindx="0"
              type="text"
              class="form-control"
              id="address"
              name="address"
              id="address"
              formControlName="address"
              [class.is-invalid]="
                sent && organizationForm?.get('address').hasError('required')
              "
            />

            <span
              class="invalid-feedback"
              *ngIf="
                sent && organizationForm?.get('address').hasError('required')
              "
              >{{ 'Mandatory Eslog field' | translate }}</span
            >
          </div>
          <div class="form-group col-12">
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="address2"
              name="address2"
              formControlName="address2"
            />
          </div>
          <div class="form-group col-12">
            <label for="city">{{ 'City' | translate }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="city"
              name="city"
              formControlName="city"
              [class.is-invalid]="
                sent && organizationForm?.get('city').hasError('required')
              "
            />

            <span
              class="invalid-feedback"
              *ngIf="sent && organizationForm?.get('city').hasError('required')"
              >{{ 'Mandatory Eslog field' | translate }}</span
            >
          </div>
          <div class="form-group col-12">
            <label for="zip">{{ 'organization.zip.label' | translate }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="zip"
              name="zip"
              formControlName="zip"
              [class.is-invalid]="
                sent && organizationForm?.get('zip').hasError('required')
              "
            />

            <span
              class="invalid-feedback"
              *ngIf="sent && organizationForm?.get('zip').hasError('required')"
              >{{ 'Mandatory field' | translate }}</span>
          </div>
          <div class="form-group col-12">
            <label for="country">{{ 'Country' | translate }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="country"
              name="country"
              formControlName="country"
              [class.is-invalid]="
                sent && organizationForm?.get('country').hasError('required')
              "
            />

            <span
              class="invalid-feedback"
              *ngIf="
                sent && organizationForm?.get('country').hasError('required')
              "
              >{{ 'Mandatory Eslog field' | translate }}</span
            >
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <h5 class="text-muted text-uppercase">
          {{ 'Identification' | translate }}
        </h5>
        <div class="row">
          <div class="form-group col-6">
            <label for="taxNumber">{{ 'Tax number' | translate }}</label>
            <input
              type="number"
              class="form-control"
              id="taxNumber"
              name="taxNumber"
              formControlName="taxNumber"
              [class.is-invalid]="
                sent && organizationForm?.get('taxNumber').hasError('required')
              "
            />

            <span
              class="invalid-feedback"
              *ngIf="
                sent && organizationForm?.get('taxNumber').hasError('required')
              "
              >{{ 'Mandatory Eslog field' | translate }}</span
            >
          </div>
          <div class="form-group col-6">
            <label for="" class="mb-5"></label>
            <div class="row">
              <div class="col-auto">
                <div
                  class="custom-control custom-checkbox-toggle custom-switch"
                >
                  <input
                    type="checkbox"
                    class="custom-control-input"
                    id="taxSubject"
                    formControlName="taxSubject"
                  />
                  <label class="custom-control-label" for="taxSubject"></label>
                </div>
              </div>
              <div class="col pl-0">
                <label class="form-check-label" for="taxSubject">{{
                  'Tax subject' | translate
                }}</label>
              </div>
            </div>
          </div>
          <div class="form-group col-12">
            <label for="companyNumber">{{
              'Registration num.' | translate
            }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="companyNumber"
              name="companyNumber"
              formControlName="companyNumber"
              [class.is-invalid]="
                sent &&
                organizationForm?.get('companyNumber').hasError('required')
              "
            />

            <span
              class="invalid-feedback"
              *ngIf="
                sent &&
                organizationForm?.get('companyNumber').hasError('required')
              "
              >{{ 'Mandatory Eslog field' | translate }}</span
            >
          </div>

          <div class="col" *ngIf="!wls.getI('organization-edit.IBAN.hidden') || !wls.getI('organization-edit.SWIFT.hidden') || !wls.getI('organization-edit.bank.hidden') ">
            <h5 class="text-muted text-uppercase mt-4">
              {{ 'Bank details' | translate }}
            </h5>
          </div>

          <div class="form-group col-12" *ngIf="!wls.getI('organization-edit.IBAN.hidden')">
            <label for="IBAN">{{ 'IBAN' | translate }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="IBAN"
              name="IBAN"
              formControlName="IBAN"
            />
          </div>

          <div class="form-group col-12" *ngIf="!wls.getI('organization-edit.SWIFT.hidden')">
            <label for="SWIFT">{{ 'BIC/SWIFT' | translate }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="SWIFT"
              name="SWIFT"
              formControlName="SWIFT"
            />
          </div>

          <div class="form-group col-12" *ngIf="!wls.getI('organization-edit.bank.hidden')">
            <label for="bank">{{ 'Name of bank' | translate }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="bank"
              name="bank"
              formControlName="bank"
            />
          </div>
        </div>
      </div>
      <div class="col-12">
        <h5 class="text-muted text-uppercase mt-4">
          {{ 'Other' | translate }}
        </h5>

        <div class="row">
          <div class="form-group col-12 col-lg-6">
            <label for="bank">{{ 'Website' | translate }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="website"
              name="website"
              formControlName="website"
            />
          </div>

          <div class="form-group col-12 col-lg-6">
            <label for="bank">{{ 'Email' | translate }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="email"
              name="email"
              formControlName="email"
            />
          </div>

          <div class="form-group col-12 col-lg-6">
            <label for="bank">{{ 'Phone' | translate }}</label>
            <input
              tabindex="0"
              type="text"
              class="form-control"
              id="phone"
              name="phone"
              formControlName="phone"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-secondary" type="button" (click)="onClose()">
      {{ 'Cancel' | translate }}
    </button>
    <button class="btn btn-primary" (click)="onSave()">
      {{ 'global.save' | translate }}
    </button>
  </div>
</div>
